import type { ReactNode } from 'react';
import { RailMenu } from '../navMenu/RailMenu';

/** Dar şerit: 56px ikon rayı, hover/tık ile flyout panel. */
export function RailLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <aside className="border-border bg-bg-elevated w-14 shrink-0 overflow-y-auto border-r">
        <RailMenu />
      </aside>
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">{children}</main>
    </div>
  );
}
